/** @type {Record<string, string>} */
const validation = {
	required: 'Ce champ est obligatoire',
	nomProjetInvalid: 'Caractères invalides : seules lettres minuscules, chiffres et tirets sont autorisés',
	selectPays: 'Vous devez sélectionner un pays',
	siteWebUrl: 'Veuillez entrer une URL valide (exemple : https://agglopole.fr ou http://www.agglopole.fr)',
	domaine: 'Veuillez entrer un nom de domaine valide (exemple : agglopole.fr ou sampass.agglopole.fr)',
	email: "Veuillez entrer une adresse email valide (exemple : nom@domaine.com)",
	facebookUrl: 'Veuillez entrer une URL valide (exemple : https://www.facebook.com/seteagglo)',
	youtubeUrl: "Veuillez entrer une URL valide (exemple : https://www.youtube.com/user/seteagglo)",
	instagramUrl: "Veuillez entrer une URL valide (exemple : https://www.instagram.com/sete_agglo/)",
	xUrl: 'Veuillez entrer une URL valide (exemple : https://x.com/SeteAgglo)',
	typeLecture: 'Veuillez sélectionner au moins un type de lecture',
	frontDomain: 'Veuillez entrer un nom de domain valide (exemple : pass.beziers-mediterranee.com ou sampass.com)',
	facebookPassUrl: 'Veuillez entrer une URL valide (exemple : https://www.facebook.com/sampass)',
	youtubePassUrl: "Veuillez entrer une URL valide (exemple : https://www.youtube.com/user/sampass)",
	instagramPassUrl: "Veuillez entrer une URL valide (exemple : https://www.instagram.com/sam_pass/)",
	xPassUrl: 'Veuillez entrer une URL valide (exemple : https://x.com/SamPass)',
	urlFormulaire: "Veuillez entrer une URL valide (exemple : https://pass.agglo.fr/inscription)",
	financeCurrencies: 'Sélectionnez au moins une devise',
	formuleFields: 'Les champs package, référence, durée et période sont obligatoires',
};

export default validation;
